import { useEffect } from "react";
import {
	ensureValidSession,
	hasStoredSession,
} from "../utilities/AuthService";

const SESSION_CHECK_INTERVAL_MS = 5 * 60 * 1000;

export function useSessionKeepAlive() {
	useEffect(() => {
		const checkSession = () => {
			if (!hasStoredSession()) {
				return;
			}
			ensureValidSession().catch(() => {});
		};

		if (hasStoredSession()) {
			checkSession();
		}

		const intervalId = window.setInterval(
			checkSession,
			SESSION_CHECK_INTERVAL_MS,
		);

		const handleVisibilityChange = () => {
			if (document.visibilityState !== "visible") {
				return;
			}
			checkSession();
		};

		const handleResume = () => {
			checkSession();
		};

		// 로그인 직후(마운트 당시 세션 없음)에도 keep-alive가 동작하도록
		const handleStorage = (event) => {
			if (
				event.key === "refresh" ||
				event.key === "access" ||
				event.key === null
			) {
				checkSession();
			}
		};

		document.addEventListener("visibilitychange", handleVisibilityChange);
		window.addEventListener("pageshow", handleResume);
		window.addEventListener("focus", handleResume);
		window.addEventListener("storage", handleStorage);

		return () => {
			window.clearInterval(intervalId);
			document.removeEventListener(
				"visibilitychange",
				handleVisibilityChange,
			);
			window.removeEventListener("pageshow", handleResume);
			window.removeEventListener("focus", handleResume);
			window.removeEventListener("storage", handleStorage);
		};
	}, []);
}
